if (!customElements.get('klaviyo-form')) {
  class KlaviyoForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.handleSubmit = this.handleSubmit.bind(this);

      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.handleSubmit);
    }

    handleSubmit(event) {
      event.preventDefault();

      const email = this.form.querySelector('input[name="email"]').value;
      const listId = this.form.querySelector('input[name="listId"]').value;
      const url = 'https://a.klaviyo.com/client/subscriptions?company_id=R4Yf5d';
      const options = {
        method: 'POST',
        headers: {
          revision: '2026-04-15',
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json'
        },
        body: `{"data":{"type":"subscription","attributes":{"profile":{"data":{"type":"profile","attributes":{"email":"${email}", "subscriptions":{"email":{"marketing":{"consent":"SUBSCRIBED"}}}}}}},"relationships":{"list":{"data":{"type":"list", "id": "${listId}"}}}}}`
      };

      fetch(url, options)
        .then(res => {
          if (res.status == 202) {
            this.querySelector('.klaviyo-form__success-message').classList.add('active');
            this.querySelector('.klaviyo-form__form').classList.remove('active');
            this.querySelector('.klaviyo-form__error-message').classList.remove('active');
          } else {
            this.querySelector('.klaviyo-form__error-message').classList.add('active');
          }
        })
        .catch(err => {
          console.error(err);
          this.querySelector('.klaviyo-form__error-message').classList.add('active');
        });
    }
  }
  
  customElements.define('klaviyo-form', KlaviyoForm);
}
